<template>
  <div class="actions-menu" :class="type" @click="trigger">
    <div class="trigger" v-if="type === 'menu'">
      <icon name="ellipsis"/>
    </div>
    <transition name="slide-fade">
      <div class="options" v-show="show">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: 'menu',
    },
  },
  data() {
    return {
      show: this.type !== 'menu',
    }
  },
  methods: {
    trigger() {
      if (this.type === 'menu') {
        this.show = !this.show
      }
    }
  }
}
</script>

<style lang="scss">
@import '~style/variables';

$_menu-width: 8rem;

.actions-menu {
  position: relative;
  .options {
    @include trans;
    border-radius: $r;
    padding: 0.25rem 0;
  }
  &.menu {
    .trigger {
      cursor: pointer;
      text-align: center;
    }
    .options {
      background: #fff;
      box-shadow: $s-md;
      left: 50%;
      margin-left: -($_menu-width / 2);
      position: absolute;
      top: 1.5rem;
      width: $_menu-width;
      z-index: 1;
    }
    &.left {
      .options {
        left: auto;
        margin-left: -6.5rem;
      }
    }
  }
  &.open {
    .trigger {
      display: none;
    }
    .options {
      padding: 0;
      > a, > .action {
        border-radius: $r;
        display: inline-block;
        padding: 0 0.5rem;
        position: relative;
        vertical-align: top;
      }
    }
  }
}

// .tr {
//   .actions-menu.open {
//     .options {
//       > a, > .action {
//         line-height: $lh * 2;
//       }
//     }
//   }
// }

// .slide-fade-enter-active, .slide-fade-leave-active {
//   @include trans;
// }
// .slide-fade-enter, .slide-fade-leave-to {
//   transform: translateY(10px);
//   opacity: 0;
// }
</style>



// WEBPACK FOOTER //
// src/views/components/globals/Actions.vue